import { HeroCarousel } from './HeroCarousel';

export default HeroCarousel;
